import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';

function About() {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate('/contact');
  };

  useEffect(() => {
    // Scroll to top on page load
    window.scrollTo(0, 0);
    
    // Update scroll progress indicator
    const updateScrollProgress = () => {
      const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
      const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrolled = (winScroll / height) * 100;
      const scrollBar = document.querySelector('.scroll-progress');
      if (scrollBar) {
        scrollBar.style.width = scrolled + '%';
      }
    };

    // Add event listener
    window.addEventListener('scroll', updateScrollProgress);
    
    // Clean up
    return () => window.removeEventListener('scroll', updateScrollProgress);
  }, []);

  return (
    <div className="w-full">
      {/* Scroll Progress Indicator */}
      <div className="scroll-progress"></div>
      
      {/* Hero Section */}
      <header className="bg-white">
        <div className="container">
          <div className="flex justify-between items-center py-8 flex-col-mobile">
            <div>
              <h1 className="mb-4">
                About <span className="text-flame">OnFire</span>
              </h1>
              <p className="mb-8 text-gray-600">The story behind our passion for transformative software</p>
            </div>
            <div>
              <img src="/assets/monitor.png" alt="About OnFire" />
            </div>
          </div>
        </div>
      </header>

      {/* Our Story Section */}
      <section className="section bg-gray-50">
        <div className="container">
          <h2 className="section-title">Our <span className="text-flame">Story</span></h2>
          <div className="flex items-center flex-col-mobile mb-8">
            <div>
              <img src="/logo-nobg.png" alt="Our Story" className="rounded" />
            </div>
            <div>
              <p className="mb-4 text-gray-600">
                Founded in 2025, OnFire began with a simple mission: to create software that ignites business potential. 
                What started as a small team of passionate developers has grown into a full-service software company with 
                clients across industries and continents.
              </p>
              <p className="mb-4 text-gray-600">
                Our journey has been defined by innovation, perseverance, and an unwavering commitment to excellence. 
                Through economic shifts and technological revolutions, we've stayed true to our core values while 
                continuously evolving our capabilities.
              </p>
              <p className="text-gray-600">
                Today, OnFire stands as a beacon of digital transformation, helping businesses navigate the complex 
                technological landscape and emerge stronger, more efficient, and ready for the future.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="section bg-white">
        <div className="container">
          <div className="flex justify-between flex-col-mobile mb-8">
            <div className="card text-center">
              <div className="mb-4">🔥</div>
              <h3 className="mb-4">Our Mission</h3>
              <p className="text-gray-600">
                To ignite digital transformation through innovative software solutions that empower businesses 
                to achieve their full potential in an ever-evolving technological landscape.
              </p>
            </div>
            <div className="card text-center">
              <div className="mb-4">🔥</div>
              <h3 className="mb-4">Our Vision</h3>
              <p className="text-gray-600">
                To be the catalyst that transforms how businesses harness technology, creating a world where 
                every organization can thrive through digital innovation.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="section bg-gray-50">
        <div className="container">
          <h2 className="section-title">Our <span className="text-flame">Values</span></h2>
          <div className="values-grid">
            <div className="value-item">
              <h3>Innovation</h3>
              <p className="text-gray-600">
                We constantly push boundaries, embracing new technologies and methodologies 
                to deliver cutting-edge solutions.
              </p>
            </div>
            <div className="value-item">
              <h3>Excellence</h3>
              <p className="text-gray-600">
                We hold ourselves to the highest standards in everything we do, from code quality 
                to client communications.
              </p>
            </div>
            <div className="value-item">
              <h3>Integrity</h3>
              <p className="text-gray-600">
                We operate with honesty, transparency, and ethical practices, building trust with 
                every interaction.
              </p>
            </div>
            <div className="value-item">
              <h3>Collaboration</h3>
              <p className="text-gray-600">
                We believe in the power of teamwork, both internally and with our clients, to achieve 
                transformative results.
              </p>
            </div>
            <div className="value-item">
              <h3>Adaptability</h3>
              <p className="text-gray-600">
                We embrace change and maintain the flexibility to pivot quickly in response to new 
                challenges and opportunities.
              </p>
            </div>
            <div className="value-item">
              <h3>Impact</h3>
              <p className="text-gray-600">
                We measure our success by the tangible value we create for our clients and the positive 
                difference we make in their businesses.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      {/* <section className="section bg-white">
        <div className="container">
          <h2 className="section-title">Our <span className="text-flame">Team</span></h2>
          <p className="text-center mb-8 text-gray-600">
            Meet the passionate individuals who make the magic happen
          </p>
          <div className="team-grid">
            <div className="team-member">
              <img src="/team/member1.png" alt="Team Member" className="team-photo" />
              <h3>Jane Doe</h3>
              <p className="team-title">CEO & Founder</p>
              <p className="text-gray-600">
                Visionary leader with 15+ years of experience in software development and business strategy.
              </p>
            </div>
            <div className="team-member">
              <img src="/team/member2.png" alt="Team Member" className="team-photo" />
              <h3>John Smith</h3>
              <p className="team-title">CTO</p>
              <p className="text-gray-600">
                Technical genius with a passion for emerging technologies and architectural excellence.
              </p>
            </div>
            <div className="team-member">
              <img src="/team/member3.png" alt="Team Member" className="team-photo" />
              <h3>Emily Chen</h3>
              <p className="team-title">Design Director</p>
              <p className="text-gray-600">
                Award-winning designer who transforms complex concepts into intuitive user experiences.
              </p>
            </div>
            <div className="team-member">
              <img src="/team/member4.png" alt="Team Member" className="team-photo" />
              <h3>Michael Johnson</h3>
              <p className="team-title">Lead Developer</p>
              <p className="text-gray-600">
                Code craftsman with expertise in multiple programming languages and frameworks.
              </p>
            </div>
          </div>
        </div>
      </section> */}

      {/* Stats Section */}
      <section className="section bg-gray-50">
        <div className="container">
          <h2 className="section-title">Our <span className="text-flame">Impact</span></h2>
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">4+</div>
              <div className="stat-label">Projects Completed</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">10+</div>
              <div className="stat-label">Clients Worldwide</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">98%</div>
              <div className="stat-label">Client Satisfaction</div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="bg-flame text-white py-16 text-center">
        <div className="container">
          <h2 className="mb-4">Join Our Journey</h2>
          <p className="mb-8">Become part of our story as we continue to ignite digital transformation</p>
          <button className="btn btn-white" onClick={handleContactClick}>Get in Touch</button>
        </div>
      </section>
    </div>
  );
}

export default About; 